module.exports = __webpack_public_path__ + "e14.no2.811addd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e14.no2.jpg
// module id = B/XJ
// module chunks = 0